// extracted by mini-css-extract-plugin
module.exports = {"container":"B3NsT_fd","message":"__4gi9yIX_","icon":"_XweenxN","desc":"__0s_CDikU"};